import { addEventListener, removeEventListener } from "./event.js";

// local functions

var insertStyles = function insertStyles(selectors) {
  var css = "\n    ".concat(selectors.join(", "), " {\n      outline: none !important;\n    }\n  ");
  var newStyle = document.createElement("style");
  newStyle.setAttribute("data-smart-outline", "");
  newStyle.appendChild(document.createTextNode(css));
  document.head.appendChild(newStyle);
};
var removeOldStyles = function removeOldStyles() {
  var oldStyle = getOldStylesEl();
  if (oldStyle) {
    oldStyle.parentNode.removeChild(oldStyle);
  }
};
var getOldStylesEl = function getOldStylesEl() {
  return document.head.querySelector("style[data-smart-outline]");
};

/*
  ------------------------------------------------------------------------------
  Disables outline on mouse and re-enables on keyboard activity

  @param {Array} selectors The list of selectors to disable outline for
*/

var initSmartOutline = function initSmartOutline(selectors) {
  selectors = selectors || ["input:focus", "button:focus", "textarea:focus", "select:focus"];
  haltSmartOutline();
  insertStyles(selectors);
  addEventListener(document, "mousedown.smartOutline", function () {
    if (!getOldStylesEl()) {
      insertStyles(selectors);
    }
  });
  addEventListener(document, "keyup.smartOutline", function (e) {
    if (e.which == 9) {
      // tab
      removeOldStyles();
    }
  });
};

/*
  ------------------------------------------------------------------------------
  Temporarily reveals outline
*/

var showSmartOutline = function showSmartOutline() {
  removeOldStyles();
};

/*
  ------------------------------------------------------------------------------
  Halts Smart Outline
*/

var haltSmartOutline = function haltSmartOutline() {
  removeOldStyles();
  removeEventListener(document, "mousedown.smartOutline");
  removeEventListener(document, "keyup.smartOutline");
};

/*
  ------------------------------------------------------------------------------
*/

export { initSmartOutline as default, haltSmartOutline, showSmartOutline };